import axios from "axios";
import config from "../config";

export function getPresences() {
  return axios.get(`${config.api_url}/presences`);
}
